module.exports = __webpack_public_path__ + "static/media/test13_4.cb878aa8.png";